import { LotteryRule } from '../../../components/play/Types/Types';
import AbstractCRMApi from '../../AbstractCRMApi';

class LotteryRulesApi extends AbstractCRMApi {
    public endpoint: string = 'lottery_rule';

    public async updateLotteryRule(displaySlug: string, lotteryRule: LotteryRule): Promise<LotteryRule> {
        const response = await this.patch(`/${displaySlug}`, lotteryRule);

        return response.data;
    }
}

export default new LotteryRulesApi();
